export const CHECKOUT_URL =
  'https://the-core-floor-blueprint.impultienda.ar/checkout'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/5TVHjHxQgr8hksUjrf5Agh/Sin_titulo_(1080_x_1080_px).png'

export type Stat = {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '+500', label: 'Women transformed' },
  { value: '6', label: 'Volumes' },
  { value: '4', label: 'Bonuses' },
  { value: '4.9/5', label: 'Rating ⭐' },
]

export type Testimonial = {
  initials: string
  quote: string
  name: string
  location: string
}

export const topTestimonials: Testimonial[] = [
  {
    initials: 'SK',
    quote: "Week 3 and I haven't had a single accident during my run.",
    name: 'Sarah K.',
    location: 'Austin, TX',
  },
  {
    initials: 'ML',
    quote: 'Gave me back control I thought I had lost forever after my second child.',
    name: 'Michelle L.',
    location: 'London, UK',
  },
  {
    initials: 'JR',
    quote: 'The 7-Minute Reset changed my mornings completely.',
    name: 'Jennifer R.',
    location: 'Sydney, AUS',
  },
  {
    initials: 'AR',
    quote: 'Volume 1 changed how I breathe forever. Week 2 — zero accidents.',
    name: 'Amanda R.',
    location: 'Chicago, IL',
  },
  {
    initials: 'TM',
    quote: 'From wearing a pad every day to running a 5K. Not a single drop.',
    name: 'Tracy M.',
    location: 'Toronto, CAN',
  },
  {
    initials: 'HS',
    quote: 'I spent $2,000 on physio that gave me less than these PDFs.',
    name: 'Helen S.',
    location: 'Auckland, NZ',
  },
]

export const storyTestimonials: Testimonial[] = [
  {
    initials: 'AR',
    quote: 'Volume 1 changed how I breathe forever. Week 2 — zero accidents.',
    name: 'Amanda R.',
    location: 'Chicago, IL',
  },
  {
    initials: 'CW',
    quote:
      'My urgency episodes dropped from 8 to 1 per day. Seeing that number change — that was everything.',
    name: 'Claire W.',
    location: 'Manchester, UK',
  },
  {
    initials: 'TM',
    quote:
      'From wearing a pad every day to running a 5K. Not a single drop. Redondoland gave me my life back.',
    name: 'Tracy M.',
    location: 'Toronto, CAN',
  },
  {
    initials: 'RP',
    quote: 'The Travel Guide saved me on a 10-hour flight. Zero urgency panic.',
    name: 'Rachel P.',
    location: 'Denver, CO',
  },
  {
    initials: 'NB',
    quote: 'I cried reading Volume 5. I finally felt like someone understood.',
    name: 'Nicole B.',
    location: 'Melbourne, AUS',
  },
  {
    initials: 'HS',
    quote: 'I spent $2,000 on physio that gave me less than these PDFs.',
    name: 'Helen S.',
    location: 'Auckland, NZ',
  },
]

export const painPoints: string[] = [
  'Crossing your legs every time you sneeze or laugh — in public',
  "Avoiding runs and jumping classes because you can't trust your body",
  'Waking up 2–3 times at night — exhausted every morning',
  'Wearing pads "just in case" — like it\'s become permanent',
  'Avoiding intimacy because of pain or fear',
  'Googling the same exercises — never finding a real plan',
]

export type Volume = {
  number: string
  title: string
  description: string
}

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'The Foundation',
    description:
      'Most programs skip this entirely. Master the breath-pressure connection that controls everything — without it, no exercise works the way it should.',
  },
  {
    number: '02',
    title: 'The Anti-Pooch Method',
    description:
      "That lower belly pooch isn't a fat problem — it's a switched-off deep core. This volume rebuilds your internal corset from zero.",
  },
  {
    number: '03',
    title: 'Bladder Control Masterclass',
    description:
      'The most complete bladder retraining protocol without a prescription. Stop leaks, silence urgency, sleep through the night.',
  },
  {
    number: '04',
    title: 'Pelvic Power & Stability',
    description:
      'Your pelvic floor is only as strong as what surrounds it. Build the glutes, hips, and stability that make everything else hold.',
  },
  {
    number: '05',
    title: 'The Intimacy & Release Guide',
    description:
      'The volume nobody talks about — and the one that changes everything. Release tension, restore comfort, reclaim connection.',
  },
  {
    number: '06',
    title: 'Functional Life',
    description:
      'Run. Jump. Lift heavy. Travel. Live without planning around your bladder. This is your graduation volume.',
  },
]

export const volumeIncludes: string[] = [
  'Protocols 100% ready — open the PDF and start',
  'Progressive structure: Foundation → Advanced',
  'Step-by-step checklists and movement cues',
  'Progress tracking tools and habit builders',
]

export type Bonus = {
  index: string
  title: string
  description: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    index: '01',
    title: 'The 7-Minute Reset™ Cheat Sheet',
    description:
      'One daily habit. Before your coffee gets cold. Printable checklist + 7-day tracker.',
    image:
      'https://cdn.magicpatterns.com/uploads/knE5UUSzLdhBYd9LLSUw3o/Diseno_sin_titulo_(6).png',
  },
  {
    index: '02',
    title: 'Travel & Office Survival Guide™',
    description:
      'Stay in control at your desk, on a plane, in traffic. Discreet protocols nobody notices.',
    image:
      'https://cdn.magicpatterns.com/uploads/7BhcweJ9yZmu2XceJRcUCS/Diseno_sin_titulo_(5).png',
  },
  {
    index: '03',
    title: 'Morning Pelvic Alignment Map™',
    description: '5 minutes to set your body up right before the day begins.',
    image:
      'https://cdn.magicpatterns.com/uploads/wbGnZhvBvWSbTjfzoxjHX6/Diseno_sin_titulo_(8).png',
  },
  {
    index: '04',
    title: '30-Day Recovery Journal™',
    description:
      'Track your progress daily. See exactly how your body changes week by week.',
    image:
      'https://cdn.magicpatterns.com/uploads/mEaU9XFkzvmZFaL4TALwH7/Diseno_sin_titulo_(7).png',
  },
]

export const offerItems: string[] = [
  '6 Volumes — the complete Core-Floor system',
  '4 Bonuses — $108 value, included free',
  'Instant PDF access · Yours forever',
]

export type ComparisonRow = {
  moment: string
  without: string
  with: string
}

export const comparisonRows: ComparisonRow[] = [
  {
    moment: 'Sneeze in public',
    without: 'Panic. Cross your legs. Hope.',
    with: 'Quick reflex. No leak. No fear.',
  },
  {
    moment: 'Try to run',
    without: 'Pad. Anxiety. Avoid it.',
    with: 'Return to impact with a protocol.',
  },
  {
    moment: 'Urgency in a meeting',
    without: 'Rush out. Everyone notices.',
    with: 'Suppression technique. Stay calm.',
  },
  {
    moment: '3am wake up',
    without: 'Broken sleep. Exhausted morning.',
    with: 'Nocturia protocol. Sleep through.',
  },
  {
    moment: 'Try to lift',
    without: 'Leak. Stop. Feel broken.',
    with: 'Functional brace active. Train freely.',
  },
  {
    moment: 'Intimacy',
    without: 'Avoid it. Feel disconnected.',
    with: 'Release done. Comfort restored.',
  },
]

export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Does this work for beginners?',
    answer: 'Yes. Volume 1 starts from zero. Every level gets real results.',
  },
  {
    question: 'How do I receive it?',
    answer:
      'Immediately after payment — email with all download links. Under 5 minutes.',
  },
  {
    question: 'Is this only for postpartum women?',
    answer: 'No. Postpartum, perimenopausal, post-surgical, or any age.',
  },
  {
    question: 'Different from YouTube?',
    answer:
      'YouTube = random isolated exercises. This = structured 6-volume system with a clear path from start to full recovery.',
  },
  {
    question: 'Is the guarantee real?',
    answer:
      '100%. Email redondoland1@gmail.com within 7 days. Full refund, zero questions.',
  },
]

export type CostRow = {
  situation: string
  cost: string
}

export const costRows: CostRow[] = [
  { situation: 'Wearing pads daily', cost: '$300–500/year forever' },
  { situation: 'Avoiding exercise', cost: 'Fitness decline, weight gain' },
  { situation: 'Waking up at night', cost: 'Chronic fatigue, brain fog' },
  { situation: 'Avoiding intimacy', cost: 'Isolation, lost confidence' },
  { situation: 'Physio appointments', cost: '$80–150 × 12 sessions minimum' },
  { situation: 'Waiting to fix itself', cost: "It won't. It gets worse." },
]
